import { createContext, useContext, useCallback, useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { useLiveRefresh } from '@/hooks/useLiveRefresh';
import { useAuth } from './AuthContext';

const NotificationsContext = createContext(null);

const EMPTY = { total: 0, by_section: {}, items: [] };

export function NotificationsProvider({ children }) {
  const { user } = useAuth();
  const [data, setData] = useState(EMPTY);

  const refresh = useCallback(async () => {
    if (!user) { setData(EMPTY); return; }
    try {
      const { data: res } = await api.get('/notifications');
      setData(res);
    } catch {
      /* silent — badges simply won't update */
    }
  }, [user]);

  useEffect(() => {
    if (!user) setData(EMPTY);
  }, [user]);

  useLiveRefresh(refresh, { enabled: Boolean(user) });

  return (
    <NotificationsContext.Provider value={{ ...data, refresh }}>
      {children}
    </NotificationsContext.Provider>
  );
}

export function useNotifications() {
  return useContext(NotificationsContext) || { ...EMPTY, refresh: () => {} };
}
